import React, { Component } from "react";
import PropTypes from "prop-types";

import DownIcon from "@material-ui/icons/KeyboardArrowDown";
import UserIcon from "@material-ui/icons/Person";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "./../../Actions/Dashboard";
import * as sessionActions from "./../../Actions/Session";

import { LANDING_MENU_BAR } from "../../constants/strings/StringsDashboard";

import LandingComponent from "./../components/LandingComponent";

class LandingContainer extends Component {
  state = {
    anchorEl: null
  };
  handleUserMenuClick = event => {
    this.setState({ anchorEl: event.currentTarget });
    // this.props.actions.actionAsyncName('string');
  };

  handleCloseUser = () => {
    this.setState({ anchorEl: null });
  };

  handleCloseSession = () => {
    this.handleCloseUser();
  };

  onChangeRoute = route => {
    this.props.actions.activePage(route);
    this.props.history.push(route);
  };
  handlerItem1Menu1 = () => {
    console.log("blas");
  };
  closeUserSession = () => {
    this.props.sessionAction.closeSession();
    this.onChangeRoute("/")
  };
  getRoles = auth => {
    var resp = "";
    for (let i = 0; i < auth.length; i++) {
      resp = resp + auth[i].rol + " ";
    }
    return resp;
  };
  getItemsMenuMini = () => {
    return [
      {
        text: LANDING_MENU_BAR.HOME,
        func: () => this.onChangeRoute("/"),
        classNames: ""
      },
      {
        text: LANDING_MENU_BAR.DASHBOARD,
        func: () => this.onChangeRoute("/Dashboard"),
        classNames: ""
      },
      {
        text: LANDING_MENU_BAR.EP,
        func: () => this.onChangeRoute("/ep"),
        classNames: ""
      },
      // {
      //   text: LANDING_MENU_BAR.MODIFICATE_USER,
      //   func: () => this.onChangeRoute("/Modificar-usuario"),
      //   classNames: ""
      // },
      {
        text: LANDING_MENU_BAR.CHANGE_PASSWORD,
        func: () => this.onChangeRoute("/Cambiar-clave"),
        classNames: ""
      },
      {
        text: LANDING_MENU_BAR.CLOSE_SESSION,
        func: () => this.closeUserSession("/Masivo"),
        classNames: ""
      }
    ]
  }

  getMenuList = () => {
    const auth = this.props.session.user.permitions;

    var resp = [
      {
        id: "landing-menu-home",
        text: LANDING_MENU_BAR.HOME,
        dropbtn: "landing-dropbtn",
        dropdownContent: "landing-dropdown-content",
        dropdown: "landing-dropdown",
        onClick: () => this.onChangeRoute("/"),
        items: []
      },
      {
        id: "landing-menu-dash",
        text: LANDING_MENU_BAR.DASHBOARD,
        dropbtn: "landing-dropbtn",
        dropdownContent: "landing-dropdown-content",
        dropdown: "landing-dropdown",
        onClick: () => this.onChangeRoute("/Dashboard"),
        items: []
      }
    ];
    let authS = this.getRoles(auth);

    if (authS.includes("ADMIN") || authS.includes("EP")) {
      resp.push({
        id: "landing-menu-ep",
        text: (
          <>
            {LANDING_MENU_BAR.EP} <DownIcon className="no-click" />
          </>
        ),
        dropbtn: "landing-dropbtn",
        dropdownContent: "landing-dropdown-content",
        dropdown: "landing-dropdown",
        items: [
          {
            text: LANDING_MENU_BAR.DOWNLOAD_FILES,
            func: () => this.onChangeRoute("/ep/archivos"),
            classNames: ""
          },
          {
            text: LANDING_MENU_BAR.CARACTERIZATIONS,
            func: () => this.onChangeRoute("/ep"),
            classNames: ""
          },
          {
            text: LANDING_MENU_BAR.CENSE_MARKET,
            func: () => this.onChangeRoute("/ep/censo"),
            classNames: ""
          },
          {
            text: LANDING_MENU_BAR.OPERATIVES,
            func: () => this.onChangeRoute("/ep/operativos"),
            classNames: ""
          },
          {
            text: LANDING_MENU_BAR.ADVERTISE,
            func: () => this.onChangeRoute("/ep/publicidad"),
            classNames: ""
          },
          {
            text: LANDING_MENU_BAR.INCAUTATIONS,
            func: () => this.onChangeRoute("/ep/incautaciones"),
            classNames: ""
          },
        ]
      });
    }

    if (authS.includes("ADMIN")) {
      // if (true) {
      // resp.push({
      //   id: "landing-menu-data",
      //   text: (
      //     <>
      //       {LANDING_MENU_BAR.DATA} <DownIcon className="no-click" />
      //     </>
      //   ),
      //   dropbtn: "landing-dropbtn",
      //   dropdownContent: "landing-dropdown-content",
      //   dropdown: "landing-dropdown",
      //   items: [
      //     // {
      //     //   text: LANDING_MENU_BAR.EP,
      //     //   func: () => this.onChangeRoute("/ep"),
      //     //   classNames: ""
      //     // },
      //     // {
      //     //   text: LANDING_MENU_BAR.REQUESTS,
      //     //   func: () => this.onChangeRoute("/ep/requests"),
      //     //   classNames: ""
      //     // },
      //     {
      //       text: LANDING_MENU_BAR.INDIVIDUALE_LOAD,
      //       func: () => this.onChangeRoute("/Individual"),
      //       classNames: ""
      //     },
      //     {
      //       text: LANDING_MENU_BAR.MASSIVE_LOAD,
      //       func: () => this.onChangeRoute("/Masivo"),
      //       classNames: ""
      //     },
      //     // {
      //     //   text: LANDING_MENU_BAR.GENERATE_INFORM,
      //     //   func: () => this.onChangeRoute("/Generar-informe"),
      //     //   classNames: ""
      //     // },
      //     {
      //       text: LANDING_MENU_BAR.INFOMR_WEEKLY,
      //       func: () => this.onChangeRoute("/Informe-semanal"),
      //       classNames: ""
      //     },
      //     {
      //       text: LANDING_MENU_BAR.CREATE_INFORMS,
      //       func: () => this.onChangeRoute("/Crear-informe"),
      //       classNames: ""
      //     },
      //     // {
      //     //   text: LANDING_MENU_BAR.COMMUNAL_FILE,
      //     //   func: () => this.onChangeRoute("/Ficha-municipal"),
      //     //   classNames: ""
      //     // }
      //   ]
      // });

      resp.push({
        id: "landing-menu-admin",
        text: (
          <>
            {LANDING_MENU_BAR.ADMIN} <DownIcon className="no-click" />
          </>
        ),
        dropbtn: "landing-dropbtn",
        dropdownContent: "landing-dropdown-content",
        dropdown: "landing-dropdown",
        items: [
          {
            text: LANDING_MENU_BAR.ADMIN_USER,
            func: () => this.onChangeRoute("/Administrar-usuario"),
            classNames: ""
          },
          {
            text: LANDING_MENU_BAR.CHANGE_LOGOS,
            func: () => this.onChangeRoute("/Cambiar-logos"),
            classNames: ""
          },
        ]
      });
    }

    // if (authS.includes("ADMIN")) {
    // // if (false) {
    //   resp.push({
    //     id: "landing-menu-admin",
    //     text: (
    //       <>
    //         {LANDING_MENU_BAR.ADMIN} <DownIcon className="no-click" />
    //       </>
    //     ),
    //     dropbtn: "landing-dropbtn",
    //     dropdownContent: "landing-dropdown-content",
    //     dropdown: "landing-dropdown",
    //     items: [
    //       {
    //         text: LANDING_MENU_BAR.CREATE_USER,
    //         func: () => this.onChangeRoute("/Crear-usuario"),
    //         classNames: ""
    //       },
    //       {
    //         text: LANDING_MENU_BAR.MODIFICATE_USER,
    //         func: () => this.onChangeRoute("/Modificar-usuario"),
    //         classNames: ""
    //       }
    //     ]
    //   });
    // }
    return resp;
  };

  getUserMenu = () => {
    const user = this.props.session.user;
    if (user.id !== 0) {
      // if (true) {
      return {
        id: "landing-menu-user",
        text: (
          <>
            <UserIcon className="no-click user-circle" />{" "}
            <label className="no-click">{`${user.nombres} ${user.apellidos}`}</label>{" "}
          </>
        ),
        // text: <><UserIcon className="no-click user-circle" /> <label className="no-click">{`Daniel Alzate`}</label> </>,
        dropbtn: "landing-dropbtn user-menu",
        dropdownContent: "landing-dropdown-content",
        dropdown: "landing-dropdown",
        items: [
          {
            text: LANDING_MENU_BAR.CHANGE_PASSWORD,
            func: () => this.onChangeRoute("/Cambiar-clave"),
            classNames: ""
          },
          {
            text: LANDING_MENU_BAR.CLOSE_SESSION,
            func: () => this.closeUserSession(),
            classNames: ""
          }
        ]
      };
    }
    return {};
  };

  render() {
    return (
      <LandingComponent
        onChangeRoute={this.onChangeRoute}
        onUserMenuClick={this.handleUserMenuClick}
        anchorUser={this.state.anchorEl}
        closeUserMenu={this.handleCloseUser}
        closeUserSession={this.handleCloseSession}
        hasFooter={this.props.hasFooter}
        menus={this.getMenuList()}
        userMenu={this.getUserMenu()}
        noHeader={this.props.generals.noHeader}
        session={this.props.session}
        system={this.props.system}
        menuSmall={{
          id: "landing-menu-smal",
          text: (
            <>
              <div className="menu-logo no-click">
                <div className="bar1 no-click"></div>
                <div className="bar2 no-click"></div>
                <div className="bar3 no-click"></div>
              </div>
            </>
          ),
          dropbtn: "landing-dropbtn",
          dropdownContent: "landing-dropdown-content margin-left--120",
          dropdown: "landing-dropdown",
          items: this.props.session.user.permitions.map(p => p.rol).includes('SADMIN') ?
            [...this.getItemsMenuMini(),
            {
              text: LANDING_MENU_BAR.CREATE_USER,
              func: () => this.onChangeRoute("/Crear-usuario"),
              classNames: ""
            }] :
            this.getItemsMenuMini()
        }}
      >
        <>{this.props.children}</>
      </LandingComponent>
    );
  }
}

LandingContainer.propTypes = {
  children: PropTypes.element.isRequired,
  history: PropTypes.object.isRequired,
  hasFooter: PropTypes.bool.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    sessionAction: bindActionCreators(sessionActions, dispatch)
  };
}

function mapStateToProps(state, props) {
  return {
    ...state
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LandingContainer);
